// NPM Imports
import React from "react";

// CSS Imports
import signInContainer from "./signincontainer.module.scss";

// Internal Imports
import { AUTH } from "../../constants";

// COMPONENT Imports
import SignIn from "../../components/SignIn";
import ReviewsCarousel from "../../components/Carousel/ReviewsCarousel";

// Destructuring
const { REVV_LOGO_URL, REVV_LOGO_STYLE } = AUTH;

const SignInContainer = () => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  const revvLogoURL = REVV_LOGO_URL[envName];
  return (
    <>
      <div
        className={signInContainer.logoWrapper}
        style={{ ...REVV_LOGO_STYLE }}>
        <img
          src={revvLogoURL}
          className={signInContainer.logoSize}
          alt="Revv"
          width="100%"
        />
      </div>

      <ReviewsCarousel />

      <div className={signInContainer.container}>
        <div className={signInContainer.authBody}>
          <div className={signInContainer.loginSection}>
            <SignIn />
          </div>
        </div>
      </div>
    </>
  );
};

export default SignInContainer;
